<template lang="pug">
div.px-5(v-if="!isLoading && isBlocked")
  v-snackbar(:value="getRatesError" color="error")
    div {{ getRatesError }}
  filtered-rates-info-modal(:value="displayFilteredRatesInfoModal" @close="displayFilteredRatesInfoModal = false")
  pagination-list-modal(
    v-if="showContactsDialog"
    v-model="showContactsDialog"
    :items="notOptedInContacts.slice(skip, skip + limit)"
    :total="notOptedInContacts.length"
    :limit="limit"
    :skip="skip"
    title="Contacts not opted in"
    description="Get started by selecting a contact to add consent proof!"
    @close="closeContactsDialog"
    @setPage="setContactsPage"
    @setPageLimit="setContactsPageLimit")
      template(slot="items" slot-scope="{ item }")
        v-layout(row)
          div
            a(@click.prevent="contactRoute(item)").pr-1 {{displayContact(item)}}

  div.recipients-underline(v-if="displayRecipientsUnderline")
    span Your bulk texting is currently limited to opted-in contacts. To send this message, remove all recipients with a&nbsp;
    v-icon(:style="{color: pendingColor}") {{ pendingIcon }}
    span &nbsp;or&nbsp;
    v-icon(:style="{color: deniedColor}") {{ deniedIcon }}
    span &nbsp;symbol, or select only one recipient.
  v-layout(column).container-margin
    div.body-1
      div.pb-1 Sending bulk text messages is restricted as we detected high opt-out/carrier filtering rates in your recent text messages.
      div.inline-content
        v-chip(v-if="optOutRate1 > optOutOkRate || optOutRate2 > optOutOkRate" text-color="white").status-chip.unhealthy Unhealthy
        v-chip(v-else text-color="white").status-chip.healthy Healthy
        span Opt-Out Rate: {{ (optOutRate1 > optOutOkRate ? optOutRate1 : optOutRate2) | percentageFormat }} (Healthy: Below {{ optOutOkRate | percentageFormat }})
        v-tooltip(bottom max-width="250px")
          span(slot='activator')
            div.pl-2
              v-icon.tooltip-color.icon-margin-fix info_outlined
              span.tooltip-color What is opt-out rate?
          div
            div Opt-out Rate: (%) Shows how many contacts may not want to receive your texts. They may have unsubscribed or never opted-in in the first place.
            div Click “Get consent” below to have your recipients confirm their SMS consent. 
      div.inline-content
        v-chip(v-if="filteredRate1 > filteredOkRate || filteredRate2 > filteredOkRate" text-color="white").status-chip.unhealthy Unhealthy
        v-chip(v-else text-color="white").status-chip.healthy Healthy
        span Carrier messagging filtering (30007 error): {{ (filteredRate1 > filteredOkRate ? filteredRate1 : filteredRate2) | percentageFormat }} (Healthy: Below {{ filteredOkRate | percentageFormat }})
        v-tooltip(bottom max-width="250px")
          span(slot='activator') 
            div.pl-2
              v-icon.tooltip-color.icon-margin-fix info_outlined
              span.tooltip-color What is carrier filtered rate?
          div
            div Carrier Filtered Rate: (%) Shows how many texts were blocked by mobile carriers because your messages were detected as spam.
            div Click “Learn to avoid carrier filtering” below to learn how to write texts that get delivered!   
      div.pt-1.font-weight-bold To regain full access, improve your opt-out/carrier filtered rates. Continued high opt-out/filter rates might lead to loss of all texting capabilities. 

    div.py-2
      v-btn(
        v-if="filteredRate1 > filteredOkRate || filteredRate2 > filteredOkRate"
        color='primary'
        outline
        @click="displayFilteredRatesInfoModal = true") Learn To Avoid Carrier Filtering
      span(v-if="optOutRate1 > optOutOkRate || optOutRate2 > optOutOkRate")
        v-btn(color='primary' @click="goToEmail") Get Consent
        v-btn(color='primary' outline @click="openContactsDialog") Add Consent for Contact
      
    
    </template>
<script>
import { createNamespacedHelpers, mapState } from 'vuex';
import PaginationListModal from '@/Core/components/PaginationListModal'
import FilteredRatesInfoModal from './FilteredRatesInfoModal.vue';
import {
  ES_STATUS,
  STATUS_ICON,
  STATUS_COLOR,
} from '@/Contacts/config/profile-optin-status'


const { mapState: mapUserSmsErrorRatesState, mapActions: mapUserSmsErrorRatesActions } = createNamespacedHelpers(
  'userSmsErrorRates',
);
const { mapState: mapUserInformationState, mapGetters: mapUserInformationGetters } =
  createNamespacedHelpers('userInformation');

const { mapState: mapRecipientsState } = createNamespacedHelpers(
  'recipients',
);

export default {
  data() {
    return {
      showContactsDialog: false,
      limit: 15,
      skip: 0,
      page: 1,
      displayFilteredRatesInfoModal: false,
    };
  },
  components: {
    PaginationListModal, FilteredRatesInfoModal
  },
  computed: {
    ...mapUserSmsErrorRatesState([
      'optOutRate1',
      'filteredRate1',
      'optOutRate2',
      'filteredRate2',
      'optOutOkRate',
      'filteredOkRate',
      'isBlocked',
      'isLoading',
      'getRatesError'
    ]),
    ...mapRecipientsState([
      'toSelected',
    ]),
    ...mapUserInformationState(['user']),
    ...mapUserInformationGetters(['userHasFeatureFlag', 'hasAccessToFeature']),
    notOptedInContacts() {
      return this.toSelected.filter(item => item.opt_in_status && item.opt_in_status !== ES_STATUS.approved)
    },
    displayRecipientsUnderline() {
      return this.toSelected.length > 1 && this.notOptedInContacts.length > 0;
    },
    pendingColor() {
      return STATUS_COLOR.pending;
    },
    deniedColor() {
      return STATUS_COLOR.denied;
    },
    pendingIcon() {
      return STATUS_ICON.pending;
    },
    deniedIcon() {
      return STATUS_ICON.denied;
    },
  },

  created() {
    this.getRates();
  },

  methods: {
    ...mapUserSmsErrorRatesActions(['getRates']),
    displayContact: item => {
      const phone = item.mobile_phone;
      if (item.first_name && item.last_name) {
        return `${item.first_name || ''} ${item.last_name || ''} (${phone})`;
      }
      return phone;
    },
    contactRoute(item) {
      this.$router.push({ name: 'contact-profile', params: { id: item.id }, hash: '#consent' });
    },
    goToEmail() {
      this.$router.push('/communications/email#consent');
    },
    openContactsDialog() {
      this.showContactsDialog = true;
    },
    closeContactsDialog() {
      this.showContactsDialog = false;
    },
    setContactsPage(page) {
      this.page = page;
      this.skip = (page - 1) * this.limit;
    },
    setContactsPageLimit(limit) {
      this.limit = limit;
      this.setContactsPage(1)
    },
  },
  filters: {
    percentageFormat(value) {
      return (value * 100).toFixed(1) + '%';
    },
  },
};
</script>

<style scoped lang="scss">
.container-margin {
  margin: 0px 0px 25px 25px !important;
  border: 2px solid rgba(0,0,0,0.24);
  padding: 15px 15px 10px 15px;
}
.recipients-underline {
  color: var(--v-error-base);
  margin-top: -40px;
  margin-left: 30px;
  margin-bottom: 10px;
  padding-bottom: 15px;
}

.inline-content {
  display: flex;
  align-items: center;
}

.icon-margin-fix {
  margin-right: -20px;
}

.tooltip-color {
  color: var(--v-primary-base) !important
}

.error-color {
  color: var(--v-error-base) !important
}

.status-chip {
  border-radius: 0px !important;
  /deep/ .v-chip__content {
      height: auto !important;
  }
}
.healthy {
    background: var(--v-success-base);
  }
.unhealthy {
  background: var(--v-warning-darken1);
}
</style>